'use client'

import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import Link from 'next/link';
import { Logo } from '@/components/logo';
import { InfiniteSlider } from '@/components/ui/infinite-slider';

// Social Media Logos
import Image from 'next/image';

const SocialMediaLogos = {
  LinkedIn: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#0A66C2] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/linkedin.svg" alt="LinkedIn" width={22} height={22} className="invert" />
    </div>
  ),
  Facebook: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#1877F2] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/facebook.svg" alt="Facebook" width={22} height={22} className="invert" />
    </div>
  ),
  Instagram: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/instagram.svg" alt="Instagram" width={22} height={22} className="invert" />
    </div>
  ),
  X: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-black rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/twitter.svg" alt="X" width={22} height={22} className="invert" />
    </div>
  ),
  YouTube: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#FF0000] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/youtube.svg" alt="YouTube" width={22} height={22} className="invert" />
    </div>
  ),
  Pinterest: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#E60023] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/pinterest.svg" alt="Pinterest" width={22} height={22} className="invert" />
    </div>
  ),
  TikTok: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-black rounded-full p-1 flex items-center justify-center">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
        <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    </div>
  ),
  Reddit: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#FF4500] rounded-full p-1 flex items-center justify-center">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
        <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/>
      </svg>
    </div>
  ),
  Snapchat: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#FFFC00] rounded-full p-1 flex items-center justify-center">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="black">
        <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.2.36-1.335.81-.044.149 0 .374.104.659 0 .045.734 1.632 2.324 1.887.194.03.374.105.494.164.12.045.24.105.3.164.104.09.184.179.224.375.057.374-.324.988-3.484 1.422-.049 0-.164.09-.255.484-.09.404-.104.704-.225.838-.119.135-.27.165-.644.21-.045 0-.254.015-.614.015-.135 0-.3 0-.48-.016-.345-.029-.664-.119-1.005-.299-.045-.015-.09-.045-.12-.06a4.691 4.691 0 0 0-.585-.12c-.404-.046-1.124.362-2.219.362-1.154 0-1.784-.406-2.218-.375-.15.016-.345.075-.645.12-1.394.283-1.863.299-2.218.299-.164 0-.299 0-.329-.015-.374-.044-.54-.074-.664-.21-.12-.134-.12-.435-.225-.839-.09-.374-.214-.484-.254-.48-3.169-.437-3.53-1.002-3.485-1.401.044-.195.104-.285.209-.375.06-.06.18-.119.315-.164.104-.045.3-.094.48-.134 1.575-.256 2.309-1.843 2.324-1.873.104-.299.135-.51.105-.664-.135-.436-.9-.629-1.334-.764-.764-.045-.016-.12-.044-.21-.075-.81-.344-1.274-.75-1.215-1.17 0-.374.299-.704.75-.839.134-.045.3-.074.449-.074.134 0 .299.015.449.09.374.18.748.3 1.034.3.185 0 .3-.044.399-.104 0-.149-.015-.314-.044-.493l-.015-.18c-.104-1.648-.225-3.684.313-4.862C7.426 1.232 10.802.788 11.747.788l.459.005z"/>
      </svg>
    </div>
  ),
  Threads: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-white rounded-full p-1 flex items-center justify-center">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="black">
        <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.506C2.35 18.321 1.5 15.8 1.5 12.37V12a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.376c0 3.124.770 5.343 2.288 6.591 1.541 1.264 3.955 2.04 7.093 2.033h.016c2.582.007 4.67-.766 6.205-2.297 1.303-1.297 2.13-3.166 2.38-5.335a.5.5 0 0 1 .577-.411.509.509 0 0 1 .41.578c-.281 2.453-1.234 4.606-2.762 6.126C17.305 21.055 14.9 24 12.186 24zm0-21.5h-.013C9.366 2.527 6.755 3.586 4.948 5.786 3.13 8 2.41 11.208 2.565 15.087a.5.5 0 0 1-.46.537.509.509 0 0 1-.538-.46c-.168-4.153.56-7.646 2.596-10.106C6.058 2.445 9.015 1 12.173 1h.014c3.104 0 5.68 1.446 7.45 4.192 1.355 2.106 2.064 4.913 2.112 8.325V15h-2.2a5.994 5.994 0 0 0-5.173-3c-3.43 0-6.067 2.86-6.067 6.5s2.636 6.5 6.066 6.5a5.531 5.531 0 0 0 4.956-3 .5.5 0 0 1 .67-.215.5.5 0 0 1 .214.67 6.531 6.531 0 0 1-5.84 3.546c-3.92 0-7.065-3.358-7.065-7.5 0-4.143 3.146-7.5 7.066-7.5C16.493 11 18.5 12.743 19.24 15h1.51v-.372l-.005-.415c-.045-3.208-.71-5.835-1.943-7.737C17.19 3.792 14.933 2.5 12.187 2.5z"/>
      </svg>
    </div>
  ),
  Mastodon: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#6364FF] rounded-full p-1 flex items-center justify-center">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
        <path d="M23.268 5.313c-.35-2.578-2.617-4.61-5.304-5.004C17.51.242 15.792 0 11.813 0h-.03c-3.98 0-4.835.242-5.288.309C3.882.692 1.496 2.518.917 5.127.64 6.412.61 7.837.661 9.143c.074 1.874.088 3.745.26 5.611.118 1.24.325 2.47.62 3.68.55 2.237 2.777 4.098 4.96 4.857 2.336.792 4.849.923 7.256.38.265-.061.527-.132.786-.213.585-.184 1.27-.39 1.774-.753a.057.057 0 0 0 .023-.043v-1.809a.052.052 0 0 0-.02-.041.053.053 0 0 0-.046-.01 20.282 20.282 0 0 1-4.709.545c-2.73 0-3.463-1.284-3.674-1.818a5.593 5.593 0 0 1-.319-1.433.053.053 0 0 1 .066-.054c1.517.363 3.072.546 4.632.546.376 0 .75 0 1.125-.01 1.57-.044 3.224-.124 4.768-.422.038-.008.077-.015.11-.024 2.435-.464 4.753-1.92 4.989-5.604.008-.145.03-1.52.03-1.67.002-.512.167-3.63-.024-5.545zm-3.748 9.195h-2.561V8.29c0-1.309-.55-1.976-1.67-1.976-1.23 0-1.846.79-1.846 2.35v3.403h-2.546V8.663c0-1.56-.617-2.35-1.848-2.35-1.112 0-1.668.668-1.67 1.977v6.218H4.822V8.102c0-1.31.337-2.35 1.011-3.12.696-.77 1.608-1.164 2.74-1.164 1.311 0 2.302.5 2.962 1.498l.638 1.06.638-1.06c.66-.999 1.65-1.498 2.96-1.498 1.13 0 2.043.395 2.74 1.164.675.77 1.012 1.81 1.012 3.12z"/>
      </svg>
    </div>
  ),
  Tumblr: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#36465D] rounded-full p-1 flex items-center justify-center">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
        <path d="M14.563 24c-5.093 0-7.031-3.756-7.031-6.411V9.747H5.116V6.648c3.63-1.313 4.512-4.596 4.71-6.469C9.84.051 9.941 0 9.999 0h3.517v6.114h4.801v3.633h-4.82v7.47c.016 1.001.375 2.371 2.207 2.371h.09c.631-.02 1.486-.205 1.936-.419l1.156 3.425c-.436.636-2.4 1.374-4.156 1.404h-.178l.011.002z"/>
      </svg>
    </div>
  )
}

// Communication App Logos
const CommunicationLogos = {
  Telegram: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#0088cc] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/telegram.svg" alt="Telegram" width={22} height={22} className="invert" />
    </div>
  ),
  WhatsApp: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#25D366] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/whatsapp.svg" alt="WhatsApp" width={22} height={22} className="invert" />
    </div>
  ),
  Viber: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#7360f2] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/viber.svg" alt="Viber" width={22} height={22} className="invert" />
    </div>
  ),
  Slack: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#4A154B] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/slack.svg" alt="Slack" width={22} height={22} className="invert" />
    </div>
  ),
  Discord: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#5865F2] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/discord.svg" alt="Discord" width={22} height={22} className="invert" />
    </div>
  ),
  Teams: (props: React.SVGProps<SVGSVGElement>) => (
    <div className="bg-[#6264A7] rounded-full p-1 flex items-center justify-center">
      <Image src="/logos/teams.svg" alt="Teams" width={22} height={22} className="invert" />
    </div>
  ),
}

const IntegrationCard = ({ 
  children, 
  className, 
  isCenter = false 
}: { 
  children: React.ReactNode; 
  className?: string; 
  position?: 'left-top' | 'left-middle' | 'left-bottom' | 'right-top' | 'right-middle' | 'right-bottom'; 
  isCenter?: boolean 
}) => {
  return (
    <div className={cn('relative z-30 flex size-12 rounded-full border border-indigo-500/30 bg-[#191627] shadow-sm shadow-indigo-500/20', className)}>
      <div className={cn('m-auto size-fit *:size-9', isCenter && '*:size-10')}>{children}</div>
    </div>
  )
}

export function IntegrationsSection() {
  // Add client-side rendering control
  const [isClient, setIsClient] = useState(false);
  
  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <section id="integrations" className="pt-2 pb-16 relative z-0">
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/[0.03] via-transparent to-rose-500/[0.03] blur-xl -z-10" />
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Powerful Integrations
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
          {/* Social Media Integration - Left Side */}
          <div className="bg-[#191627]/70 border border-indigo-500/10 rounded-xl p-6 md:p-8 shadow-xl shadow-indigo-500/5">
            <h3 className="text-2xl font-semibold mb-4 text-center bg-gradient-to-r from-indigo-400 to-rose-400 text-transparent bg-clip-text">Social Media Integration</h3>
            <p className="text-center text-gray-300 mb-2">
              Complement your news clippings with posts on your social media platforms.
            </p>
            <p className="text-center text-gray-300 mb-6">
              Share insights and reactions instantly.
            </p>
            
            <div className="bg-[#141223]/70 group relative mx-auto max-w-[22rem] flex flex-col justify-center items-center h-[220px] space-y-6 pt-4 pb-4 [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)] sm:max-w-md rounded-lg border border-indigo-500/10 p-4 -mt-2">
              <div
                role="presentation"
                className="absolute inset-0 -z-10 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:32px_32px] opacity-30">
              </div>
              
              {/* First row - Static */}
              <div className="w-full flex justify-center gap-6">
                <IntegrationCard>
                  <SocialMediaLogos.LinkedIn />
                </IntegrationCard>
                <IntegrationCard>
                  <SocialMediaLogos.Facebook />
                </IntegrationCard>
                <IntegrationCard>
                  <SocialMediaLogos.Instagram />
                </IntegrationCard>
                <IntegrationCard>
                  <SocialMediaLogos.TikTok />
                </IntegrationCard>
              </div>

              {/* Second row - Right to Left - Animated */}
              <div className="w-full">
                <InfiniteSlider
                  gap={24}
                  speed={20}
                  speedOnHover={10}
                  reverse>
                  <IntegrationCard>
                    <SocialMediaLogos.X />
                  </IntegrationCard>
                  <IntegrationCard>
                    <SocialMediaLogos.YouTube />
                  </IntegrationCard>
                  <IntegrationCard>
                    <SocialMediaLogos.Reddit />
                  </IntegrationCard>
                  <IntegrationCard>
                    <SocialMediaLogos.Threads />
                  </IntegrationCard>
                </InfiniteSlider>
              </div>
              
              {/* Third row - Static */}
              <div className="w-full flex justify-center gap-6">
                <IntegrationCard>
                  <SocialMediaLogos.Pinterest />
                </IntegrationCard>
                <IntegrationCard>
                  <SocialMediaLogos.Snapchat />
                </IntegrationCard>
                <IntegrationCard>
                  <SocialMediaLogos.Tumblr />
                </IntegrationCard>
                <IntegrationCard>
                  <SocialMediaLogos.Mastodon />
                </IntegrationCard>
              </div>
            </div>
          </div>
          
          {/* Communication Apps Integration - Right Side */}
          <div className="bg-[#191627]/70 border border-rose-500/10 rounded-xl p-6 md:p-8 shadow-xl shadow-rose-500/5 overflow-hidden">
            <h3 className="text-2xl font-semibold mb-4 text-center bg-gradient-to-r from-rose-400 to-indigo-400 text-transparent bg-clip-text">Communication Apps</h3>
            <p className="text-center text-gray-300 mb-8">
              Get notified in your favorite communication apps. Stay updated with real-time alerts.
            </p>
            
            <div className="w-full group relative mx-auto flex items-center justify-between min-h-56 sm:max-w-xs mt-8 sm:mt-16">
              {isClient && (
                <>
                  <div
                    role="presentation"
                    className="bg-gradient-to-b from-rose-500/5 to-transparent border-rose-500/10 absolute inset-0 z-10 aspect-square animate-spin items-center justify-center rounded-full border-t duration-1000">
                  </div>
                  <div
                    role="presentation"
                    className="bg-gradient-to-b from-indigo-500/5 to-transparent border-indigo-500/10 absolute inset-16 z-10 aspect-square scale-90 animate-spin items-center justify-center rounded-full border-t duration-1000">
                  </div>
                </>
              )}
              <div className="bg-gradient-to-b from-rose-500/10 to-transparent absolute inset-0 flex aspect-square items-center justify-center rounded-full border-t border-rose-500/10 to-25%">
                <IntegrationCard className="-translate-x-1/6 absolute left-0 top-1/4 -translate-y-1/4 border-rose-500/20">
                  <CommunicationLogos.Telegram />
                </IntegrationCard>
                <IntegrationCard className="absolute top-0 -translate-y-1/2 border-rose-500/20">
                  <CommunicationLogos.WhatsApp />
                </IntegrationCard>
                <IntegrationCard className="translate-x-1/6 absolute right-0 top-1/4 -translate-y-1/4 border-rose-500/20">
                  <CommunicationLogos.Viber />
                </IntegrationCard>
              </div>
              <div className="bg-gradient-to-b from-indigo-500/10 to-transparent absolute inset-16 flex aspect-square scale-90 items-center justify-center rounded-full border-t border-indigo-500/10 to-25%">
                <IntegrationCard className="absolute top-0 -translate-y-1/2 border-indigo-500/20">
                  <CommunicationLogos.Slack />
                </IntegrationCard>
                <IntegrationCard className="absolute left-0 top-1/4 -translate-x-1/4 -translate-y-1/4 border-indigo-500/20">
                  <CommunicationLogos.Discord />
                </IntegrationCard>
                <IntegrationCard className="absolute right-0 top-1/4 -translate-y-1/4 translate-x-1/4 border-indigo-500/20">
                  <CommunicationLogos.Teams />
                </IntegrationCard>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 